module.exports = __webpack_public_path__ + "img/cxTrends-7.c0306f17.png";